import { useState, useEffect } from "react";
import LoginPage from "./components/LoginPage";
import SetupPage from "./components/SetupPage";
import Portal from "./components/Portal";

export default function App() {
  const [user, setUser] = useState(() => {
    try { const s = sessionStorage.getItem("boal_user"); return s ? JSON.parse(s) : null; } catch { return null; }
  });
  const [setupEmail, setSetupEmail] = useState(null);
  const [fade, setFade] = useState(false);

  useEffect(() => { setTimeout(() => setFade(true), 50); }, []);
  useEffect(() => {
    const l = document.createElement("link");
    l.href = "https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&display=swap";
    l.rel = "stylesheet";
    document.head.appendChild(l);
  }, []);

  const login = u => {
    sessionStorage.setItem("boal_user", JSON.stringify(u));
    setFade(false); setTimeout(() => { setUser(u); setSetupEmail(null); setTimeout(() => setFade(true), 50); }, 300);
  };
  const needsSetup = email => { setFade(false); setTimeout(() => { setSetupEmail(email); setTimeout(() => setFade(true), 50); }, 300); };
  const logout = () => {
    sessionStorage.removeItem("boal_user");
    localStorage.removeItem("boal_section"); // clear saved section on logout
    setFade(false); setTimeout(() => { setUser(null); setSetupEmail(null); setTimeout(() => setFade(true), 50); }, 300);
  };
  const updateUser = u => {
    sessionStorage.setItem("boal_user", JSON.stringify(u));
    setUser(u);
  };

  return (
    <div style={{ opacity: fade ? 1 : 0, transition: "opacity 0.4s ease" }}>
      {user ? <Portal user={user} onLogout={logout} onUpdate={updateUser} /> :
       setupEmail ? <SetupPage email={setupEmail} onComplete={login} /> :
       <LoginPage onLogin={login} onNeedsSetup={needsSetup} />}
    </div>
  );
}
